var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0d944a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cart-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512,204.69a51.27,51.27,0,0,0-51.2-51.22H427.7L287.18,12.9a44.12,44.12,0,0,0-62.36,0L84.3,153.47H51.2a51.21,51.21,0,0,0-24.55,96.15L66.76,450.23A77,77,0,0,0,142.07,512H369.93a77,77,0,0,0,75.31-61.76l40.11-200.62A51.26,51.26,0,0,0,512,204.69ZM242.92,31a18.52,18.52,0,0,1,26.16,0L391.5,153.47h-271ZM51.2,179.08H460.8a25.61,25.61,0,0,1,0,51.22H51.2a25.61,25.61,0,0,1,0-51.22ZM420.14,445.22a51.34,51.34,0,0,1-50.21,41.17H142.07a51.34,51.34,0,0,1-50.21-41.18L54,255.91H458ZM243.2,409.56V332.74a12.8,12.8,0,1,1,25.6,0v76.83a12.8,12.8,0,1,1-25.6,0Zm-64,0V332.74a12.8,12.8,0,1,1,25.6,0v76.83a12.8,12.8,0,1,1-25.6,0Zm128,0V332.74a12.8,12.8,0,1,1,25.6,0v76.83a12.8,12.8,0,1,1-25.6,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.f01e0dc7f8e61ac70709dcece23488d0.svg";
export { ForwardRef as ReactComponent };